module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/job-posts/job-posts-edit/job-posts-edit.component.css
// module id = ./src/app/components/job-posts/job-posts-edit/job-posts-edit.component.css
// module chunks = main